var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCardList(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.701,
    height: 21.526,
    viewBox: "0 0 28.701 21.526",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "card-list",
    transform: "translate(0 -4.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_197",
    "data-name": "Path 197",
    d: "M26.01,6.294H2.691a.9.9,0,0,0-.9.9V23.335a.9.9,0,0,0,.9.9H26.01a.9.9,0,0,0,.9-.9V7.191A.9.9,0,0,0,26.01,6.294ZM2.691,4.5A2.691,2.691,0,0,0,0,7.191V23.335a2.691,2.691,0,0,0,2.691,2.691H26.01A2.691,2.691,0,0,0,28.7,23.335V7.191A2.691,2.691,0,0,0,26.01,4.5Z",
    transform: "translate(0)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_198",
    "data-name": "Path 198",
    d: "M11.25,16.631a.9.9,0,0,1,.9-.9H24.7a.9.9,0,0,1,0,1.794H12.147A.9.9,0,0,1,11.25,16.631Zm0-4.485a.9.9,0,0,1,.9-.9H24.7a.9.9,0,0,1,0,1.794H12.147A.9.9,0,0,1,11.25,12.147Zm0,8.969a.9.9,0,0,1,.9-.9H24.7a.9.9,0,0,1,0,1.794H12.147A.9.9,0,0,1,11.25,21.116Z",
    transform: "translate(-2.281 -1.369)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_199",
    "data-name": "Path 199",
    d: "M8.544,12.147a.9.9,0,1,1-.9-.9A.9.9,0,0,1,8.544,12.147Z",
    transform: "translate(-1.369 -1.369)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_200",
    "data-name": "Path 200",
    d: "M8.544,17.772a.9.9,0,1,1-.9-.9A.9.9,0,0,1,8.544,17.772Z",
    transform: "translate(-1.369 -2.509)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_201",
    "data-name": "Path 201",
    d: "M8.544,23.4a.9.9,0,1,1-.9-.9A.9.9,0,0,1,8.544,23.4Z",
    transform: "translate(-1.369 -3.649)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardList);
export default __webpack_public_path__ + "static/media/card-list.29e30cf13a3ec5be4f97fe1b80b05df2.svg";
export { ForwardRef as ReactComponent };